import React, {useState, useEffect, useContext} from 'react'
import ContextProvider, {AppContext} from '../ContextProvider'
import Button from '@material-ui/core/Button'
import {makeStyles, withStyles} from '@material-ui/core/styles'
import PinGreen from "../assets/pinGreen.svg"
import PinGray from '../assets/pinGray.svg'
import PinRed from '../assets/pinRed.svg'
import {useHistory, useLocation, useParams} from 'react-router-dom'
import axios from 'axios'

const useStyles = makeStyles({
    greenButton: {
        background: '#32702F',
        border: 1,
        borderRadius: 3,
        color: '#FFFFFF',
        height: 48,
        width: '100%',
        '&:hover': {
            background: 'green',
        },
        margin: '0 0 5px 0',
    },
    // green: {
    //     background: '#32702F',
    // },
    // green: {
    //     background: '#32702F',
    // }
})

// border: 2px solid #6BB03A;
// background-color: #32702F;

export default (props) => {
    const defOptions = require('../staticData/filter.json')
    const classes = useStyles()
    const context = useContext(AppContext)
    const [marker, setMarker] = useState(null)
    const [options, setOptions] = useState(defOptions)
    const location = useLocation();

    const history = useHistory()

    const { id } = useParams()

    useEffect(() => {
        setMarker({})
        setOptions([...defOptions])
        options[0].isActive = false
        options[1].isActive = false
        options[2].isActive = false
        options[3].isActive = false
        options[4].isActive = false
        options[5].isActive = false
        return () => {
            context.setPlace('', ContextProvider.ActionsEnum.BACK)
        }
    }, [])

    const handleOptions = (index) => {
        const opt = [...options]
        opt[index].isActive = !opt[index].isActive
        setOptions(opt)
    }

    const onSubmit = async () => {

        const objKeys = Object.keys(options)
        let check = false
        objKeys.forEach(key => {
            const value = options[key].isActive
            if (value === true) {
                check = true
            }
        })
        if (check === false) {
            alert("Musíte označit aspoň jeden druh kontejneru")

            return
        }

        const lat = context.state.lat
        const lng = context.state.lng

        marker.lat = lat
        marker.lng = lng
        marker.cluster = {
            "paper": options[0].isActive,
            "plastic": options[1].isActive,
            "glass": options[2].isActive,
            "drinkCarton": options[3].isActive,
            "metal": options[4].isActive,
            "courtyard": options[5].isActive
        }

        let url = `${process.env.REACT_APP_API}/api/markers`
        await axios.post(url, marker)
        history.goBack()
    }

    return (
        <div id="markers">
            <>
                <div id="panelFilter" className="filterAdmin">
                    <ul>
                        {options.map((item, index) => (
                            <li key={item.index}
                                onClick={() => {
                                    handleOptions(index)
                                }}
                                className={item.isActive ? 'active' : 'noActive'}>
                                {item.title}
                            </li>
                        ))}
                    </ul>
                </div>
                <Button variant="contained" className={classes.greenButton} onClick={() => onSubmit()}>Uložit</Button>
                <Button variant="contained" className={classes.greenButton} onClick={() => history.goBack()}>ZPĚT</Button>
            </>
        </div>
    )
}
